import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "@/i18n/translations";
import { safeGet, safeSet } from "@/lib/storage";

const I18nContext = createContext();

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const storage = typeof window !== "undefined" ? window.localStorage : null;
    const stored = safeGet(storage, "tw_lang", "fr");
    return translations[stored] ? stored : "fr";
  });

  useEffect(() => {
    const storage = typeof window !== "undefined" ? window.localStorage : null;
    safeSet(storage, "tw_lang", lang);
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const parts = path.split(".");
    let cur = translations[lang] || translations.fr;
    for (const p of parts) {
      if (cur == null) return path;
      cur = cur[p];
    }
    return cur ?? path;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
